import { ViewStyle } from 'react-native';
import { TextWrap as Text, View, styles as sc } from '../Themed';
import Colors from '../../constants/Colors';
// Image assets
import TextButton from '../elements/TextButton';

type SubBoxPropsType = {
  title: string;
  cost: string;
  period: 'Month' | 'Year';
  description: string;
  discountPercent?: number;
  onSubmit: () => void;
  style?: ViewStyle;
};
export const SubscriptionBox = (props: SubBoxPropsType) => {
  return (
    <View
      style={{
        backgroundColor: props.discountPercent ? Colors.snapCalorie.orange : 'white',
        padding: 2,
        borderRadius: 5,
        borderColor: props.discountPercent ? Colors.snapCalorie.orange : '#ccc',
        borderWidth: 2,
        shadowColor: '#ccc',
        shadowOffset: { height: 4, width: 4 },
        shadowOpacity: 0.6,
      }}
    >
      {props.discountPercent && (
        <Text style={[sc.blockParagraph, { minHeight: 50, fontSize: 18, fontWeight: '800', color: '#000' }]}>
          SAVE {props.discountPercent}%
        </Text>
      )}
      {!props.discountPercent && <View style={{ minHeight: 50 }} />}
      <View
        style={[
          {
            flex: 1,
            flexDirection: 'column',
            backgroundColor: '#fff',
            paddingHorizontal: 60,
            paddingVertical: 30,
          },
          props.style,
        ]}
      >
        <Text style={[sc.blockParagraph, { fontSize: 24 }]}>{props.title}</Text>
        <View style={{ flexDirection: 'row', alignSelf: 'center' }}>
          <Text style={sc.h2}>{props.cost}</Text>
          <Text> Per {props.period as string}</Text>
        </View>
        <Text style={{ marginTop: 20, width: 220, textAlign: 'center' }}>{props.description}</Text>
        <TextButton
          onPress={props.onSubmit}
          text="Subscribe"
          textStyle={sc.buttonText}
          style={[sc.buttonWrapper, { backgroundColor: Colors.snapCalorie.buttonBlue, width: 250, marginTop: 20 }]}
        />
      </View>
    </View>
  );
};

SubscriptionBox.defaultProps = {
  style: {},
  discountPercent: null,
};

export default SubscriptionBox;
